import React from 'react';
import { Button, Checkbox, notification, Form, type FormProps, Input, Card, Select, DatePicker, InputNumber, Tag, Upload } from 'antd';
import { NotificationService } from "./../../services/NotificationService";
import { DatePickerProps } from 'antd/lib';
import { RangePickerProps } from 'antd/es/date-picker';
import {
    ClearOutlined,
    UploadOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import moment from 'moment';
import dayjs from 'dayjs';
import SelectBox from '../../components/select/SelectBox';
import _ from 'lodash';

const { TextArea } = Input;


interface Props {
    record: any
    onFinish: () => void
}

export default function Create(props: Props) {

    const [form] = Form.useForm();
    const [specificUsers, setSpecificUsers] = React.useState<any[]>([])
    const [isTypeAll, setIsTypeAll] = React.useState<boolean>(true)
    const [file, setFile] = React.useState<any>();

    const handleFileChange = (info: any) => {
        const uploadedFile = info.file;
        setFile(uploadedFile);
    };

    React.useEffect(() => {
        form.resetFields();
        form.setFieldsValue({
            ...props?.record,
            'expired_date': props?.record?.expired_date && moment(props?.record?.expired_date).isValid() ? dayjs(props?.record?.expired_date) : undefined
        })

        setIsTypeAll(true)
        setSpecificUsers([])
    }, [props?.record])


    const onFinish: FormProps["onFinish"] = async (values) => {

        if (props?.record?.id) {
            // var res = await NotificationService.updateCoupon(values, props.record.id)
        } else {

            const formData = new FormData();
            formData.append('type', values.type);
            formData.append('subject', values.subject);
            formData.append('description', values.description);
            formData.append('members', JSON.stringify(specificUsers.map(item => item.value)));
            if (file) {
                formData.append('notification', file);
            }

            var res = await NotificationService.saveNotification(formData)

        }

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            if (!props?.record?.id) {
                form.resetFields();
                setSpecificUsers([])
            }
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const onOk = (value: DatePickerProps['value'] | RangePickerProps['value']) => {
        console.log('onOk: ', value);
        form.setFieldValue('expired_date', value)
    };

    const onSearchServer = async (_params: any, options: any) => {
        const params = {
            keyword: _params.searchText
        }

        const res = await NotificationService.getMembers(params, options);
        return res?.data?.members || [];
    }


    return (
        <Card
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    type: 'all',
                    subject: '',
                    description: '',
                    members: []
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >

                <Form.Item
                    label="Send to"
                    name="type"
                    rules={[{ required: true, message: 'Please fill' }]}
                >
                    <Select
                        defaultValue="all"
                        style={{ width: 200 }}
                        onChange={(value) => {
                            form.setFieldValue('type', value)
                            setIsTypeAll(value == 'all' ? true : false)
                        }}
                        options={[
                            { value: 'all', label: 'All Users' },
                            { value: 'one', label: 'Specific Users' },
                        ]}
                    />
                </Form.Item>


                <Form.Item
                    label="Subject"
                    name="subject"
                    rules={[
                        { required: true, message: 'Please fill' },
                        { min: 6, message: 'Subject must be at least 6 characters long' },
                        { max: 255, message: 'Subject must be no longer than 255 characters' }]}
                >
                    <Input showCount />
                </Form.Item>

                <Form.Item
                    label="Description"
                    name="description"
                    rules={[{ required: true, message: 'Please fill' },
                    { min: 6, message: 'Subject must be at least 6 characters long' },
                    { max: 255, message: 'Subject must be no longer than 255 characters' }
                    ]}
                >
                    <TextArea rows={4} placeholder="" showCount />
                </Form.Item>

                {
                    !isTypeAll ?
                        <>
                            <Form.Item label="Specific Users" name="members" extra={
                                <>
                                    <br></br>
                                    {
                                        specificUsers.map((item: any, index: number) => {
                                            return (
                                                <Tag key={`tag_${index}`} color='black'>{item.label}
                                                    &nbsp;
                                                    <DeleteOutlined style={{ color: 'red' }}
                                                        onClick={() => {
                                                            const foundIndexUser = _.findIndex(specificUsers, { value: item.value })
                                                            if (foundIndexUser >= 0) {
                                                                specificUsers.splice(foundIndexUser, 1)
                                                                setSpecificUsers([...specificUsers])
                                                                form.setFieldValue('members', specificUsers)
                                                            }
                                                        }} />
                                                </Tag>
                                            )
                                        })

                                    }

                                </>
                            } rules={[
                                // { required: true, message: 'Please select at least one user!' },
                                {
                                    type: 'array',
                                    min: 1,
                                    message: 'You must select at least one user!',
                                }]}
                            >
                                <SelectBox
                                    // allowClear={{ clearIcon: ClearOutlined }}  // Optional custom clear icon
                                    disabled={false}
                                    placeholder="Select an Specific Users"
                                    onSelect={(value, option: any) => {

                                        const foundUser = _.find(specificUsers, { value: option.value })
                                        if (!foundUser) {
                                            specificUsers.push(option)
                                            setSpecificUsers([...specificUsers])
                                            form.setFieldValue('members', specificUsers)
                                        }

                                    }}
                                    onSearchServer={onSearchServer}
                                />


                            </Form.Item>


                        </>

                        :
                        null
                }


                <Form.Item
                    label="Upload Photo"
                    name="photo"
                    extra="Size limit  10 MB."
                >
                    <Upload
                        beforeUpload={() => false} // Prevent auto upload
                        onChange={handleFileChange}
                        maxCount={1}
                        accept="image/*"
                    >
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'ส่งทันที'}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
